import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

import { ActivityFeedQuery, ActivityFeedResponse } from '@/types/activityFeed';
import { TransmissionReportDetailsResponse } from '@/types/transmissionReport';

export const activityFeedApiSlice = createApi({
  reducerPath: 'activityFeedApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.ActivityFeed],
  endpoints: (builder) => ({
    getPatientActivity: builder.query<ActivityFeedResponse, ActivityFeedQuery>({
      query: ({ patientId, page = 0, pageSize = 50, filters }) => {
        return {
          url: API_ENDPOINTS.ACTIVITY_FEED.LIST(patientId),
          method: 'GET',
          params: {
            page,
            pageSize,
            ...(filters && filters.length > 0 ? { filters: filters.join() } : {})
          }
        };
      },
      providesTags: (_result, _error, { patientId }) => [
        { type: API_SLICE.ActivityFeed, id: patientId }
      ]
    }),
    getReportForAlertNotes: builder.query<TransmissionReportDetailsResponse, number>({
      query: (reportId) => ({
        url: `${API_ENDPOINTS.TRANSMISSION_REPORTS.ROOT}/${reportId}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetPatientActivityQuery, useGetReportForAlertNotesQuery } = activityFeedApiSlice;
